import BaseEndpoint from '@spa/apps/trustup-pro-base-js/endpoints/BaseEndpoint';
import WorksiteCollection from '../collections/WorksiteCollection';
import ArchivedWorksiteCollection from '../collections/ArchivedWorksiteCollection';
import ActiveWorksiteCollection from '../collections/ActiveWorksiteCollection';
import Worksite from '../models/Worksite';

export default class WorksiteEndpoint extends BaseEndpoint
{

    constructor()
    {
        super(
            'worksite',
            {
                'path': 'worksites',
                'responseKey': 'worksite',
                'responseKeyPlural': 'worksites',
                'modelClass': Worksite,
                'collectionClass': WorksiteCollection
            }
        );
    }

    async index(params = {})
    {
        if ( ! params.all ) {
            params.archived = params.archived || false;
            this.setCollectionClass(params.archived ? ArchivedWorksiteCollection : ActiveWorksiteCollection);
        }
        
        let response = await super.index(params);
        this.resetCollectionClass();
        
        return response;
    }

    async archive(uuid)
    {
        let data = {archived_at: window.moment().format('YYYY-MM-DD HH:mm:ss')};
        return await this.update({url: `${this.getPath()}/${uuid}/archive-status`, uuid, data});
    }

    async unarchive(uuid)
    {
        let data = {archived_at: null};
        return await this.update({url: `${this.getPath()}/${uuid}/archive-status`, uuid, data});
    }

    async updateNotes(uuid, notes)
    {   
        let data = {notes};
        let response = await this.disableEvents().update({url: `${this.getPath()}/${uuid}/notes`, uuid, data});
        this.enableEvents();
        return response;
    }

    async updateContact(uuid, contact)
    {
        let data = {contact_uuid: contact};
        let response = await this.disableEvents().update({url: `${this.getPath()}/${uuid}/contact`, uuid, data});
        this.enableEvents();
        return response;
    }

}